export default [
  {
    path: '/gk/help-center',
    name: 'helpCenter',
    component: () => import('../views/help-center/TheEmail.vue'),
  },
  {
    path: '/gk/deepview',
    name: 'deepview',
    component: () => import('../views/deepview/TheDeepview.vue'),
  },
];
